import application from "./application"
import users from "./users"
import plantList from "./plantList";
import plant from "./plant";
import logs from "./logs";
import { combineReducers } from "redux";

const reducer = combineReducers({ application, users, plantList, plant, logs });

export default reducer;